import { getterTypes } from "./getter-types";
import { mutationTypes } from "./mutation-types";
import { actionTypes } from "./action-types";
import {
    getEmployees,
    createEmployee,
    updateEmployee,
    deleteEmployee
} from "@/services/organization";
import {validateMessages} from "@/config";

const OrganizationModule = {
    namespaced: true,
    strict: true,
    state: {
        employees: []
    },
    actions: {
        [actionTypes.FETCH_EMPLOYEES]({ commit }) {
            return new Promise((resolve, reject) => {
                getEmployees()
                    .then((response) => {
                        commit(mutationTypes.SET_EMPLOYEES, response.data);
                        resolve(response.data);
                    })
                    .catch(() => {
                        reject(validateMessages.error);
                    })
            });
        },
        [actionTypes.CREATE_EMPLOYEE]({ commit }, data) {
            return new Promise((resolve, reject) => {
                createEmployee(data)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        commit(mutationTypes.SET_ERROR, error.data);
                        reject(error);
                    })
            });
        },
        [actionTypes.UPDATE_EMPLOYEE](_, data) {
            return new Promise((resolve, reject) => {
                updateEmployee(data)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch(() => {
                        reject(validateMessages.error.text);
                    });
            });
        },
        [actionTypes.DELETE_EMPLOYEE](_, id) {
            return new Promise((resolve, reject) => {
                deleteEmployee(id)
                    .then(() => {
                        resolve("Pracownik został usunięty");
                    })
                    .catch(() => {
                        reject(validateMessages.error.text);
                    });
            });
        }
    },
    mutations: {
        [mutationTypes.SET_ERROR](state, payload) {
            console.log(payload);
            console.log(state);
        },
        [mutationTypes.SET_EMPLOYEES](state, payload) {
            state.employees = payload;
        }
    },
    getters: {
        [getterTypes.GET_EMPLOYEES](state) {
            return state.employees;
        }
    }
}

export { OrganizationModule };
